import * as Yup from 'yup';

import Values from './Components/Values';
import Prices from './Components/Prices';
import Stock from './Components/Stock';

import { formatLength } from '../../utils/util';


const headers = [
  {
    id: "brand_name",
    label: "Brand Name",
  },
  {
    id: "sku",
    label: "SKU",
  },
  {
    id: "line",
    label: "Wig Line",
  },
  {
    id: "color",
    label: "Color",
  },
  {
    id: "length",
    label: "Length",
    render: (row) => formatLength(row.length, row.length_unit),
  },
  {
    id: "material",
    label: "Type",
  },
  {
    id: "cap_size",
    label: "Cap Size",
  },
  {
    id: "price",
    label: "Price",
    currency: true,
  },
  {
    id: "current_stock",
    label: "Stock Amount",
  }
]

const filters = [
  {
    id: "current_stock",
    type: "number",
    label: "Quantity",
  }
]

const fields = [
  {
    fieldType: "debounceSearchSolo",
    name: "brand_name",
    label: "Select Wig Brand",
    url: "vendors/brands",
    fieldName: "brand_name",
    displayField: "brand_name",
    formUpdates: [{name: "vendor_id", field: "vendor_id"}],
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Wig Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Values />,
    name: "values",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Price Information",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Prices />,
    name: "prices",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Stock Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Stock />,
    name: "stock",
    size: {xs: 12, lg: 12},
  },
]

const initialValues = {
  brand_name: "",
  line: "",
  color: "",
  length: "",
  material: "",
  cap_size: "",
  hairstyle: "",
  has_highlights: false,
  cost_subtotal: "",
  price: "",
  service_price: "",
  current_stock: "",
  length_unit: "in"
}

const additionalState = {
  vendor_id: "",
}

const schema = Yup.object().shape({
  brand_name: Yup.string().required('Required'),
  line: Yup.string().nullable(),
  color: Yup.string().required('Required'),
  length: Yup.string().required('Required'),
  material: Yup.string().nullable(),
  cap_size: Yup.string().required('Required').default('M'),
  hairstyle: Yup.string().nullable(),
  cost_subtotal: Yup.number().default(0),
  price: Yup.number().default(0),
  service_price: Yup.number().default(0),
  current_stock: Yup.number().default(0)
});

export { fields, schema, initialValues, headers, filters, additionalState };
